export default function Config() {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-slate-800 mb-6">Configuration</h1>
      <p className="text-slate-500 text-sm">Feature flags, plan limits, payment gateway routing, and maintenance mode.</p>
    </div>
  );
}
